import { AfterViewInit, Component, OnInit } from '@angular/core';
declare function $(string:string): any;

@Component({
  selector: 'app-commercial',
  templateUrl: './commercial.component.html',
  styleUrls: ['./commercial.component.scss']
})
export class CommercialComponent implements OnInit, AfterViewInit {

  constructor() { }

  ngOnInit(): void {
  }

  ngAfterViewInit(){
    $('img.lightbox').lightBox(); // Select all links with lightbox class

  }
}
